import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { media } from '../data/product';
const without = ['Tool in one hand. Part in the other.', 'Light in your teeth, or on the floor.', 'Stop, reposition the beam, start again.'];
const withX1 = ['Both hands stay on the work.', 'The light points where your eyes point.', 'Swap the lens and keep going.'];
export function DemoSection() {
  return <section id="demo" aria-labelledby="demo-heading" className="scroll-mt-28 border-b border-white/10 bg-ink-900" data-id="element-447" data-mp="2gzft9f58h94q">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-448" data-mp="2ptu5f8ugw3jm">
        <h2 id="demo-heading" className="grit-headline max-w-3xl text-[clamp(2.25rem,8vw,4.5rem)] font-extrabold uppercase text-offwhite" data-id="element-449" data-mp="2pvoqqo9nhxo8">
          You don&apos;t have a third hand.
        </h2>
        <p className="mt-4 text-lg font-medium text-grit-500 sm:text-xl" data-id="element-450" data-mp="1tc7k2m4opfxf">Good. You don&apos;t need one.</p>

        <div className="mt-10 grid gap-8 lg:grid-cols-[0.85fr_1.15fr] lg:items-center" data-id="element-451" data-mp="2r8453ya3r3t9">
          <figure className="border border-white/10 bg-ink-950" data-id="element-452" data-mp="2w6e12b3ni8fx">
            <img src={media.struggle} alt="Bearded American mechanic holding a flashlight in his mouth while working on an engine" className="block h-auto w-full grayscale" data-id="element-453" data-mp="2w4kramxqr83p" />
            <figcaption className="border-t border-white/10 p-5 text-[15px] text-steel-400" data-id="element-454" data-mp="288yhepdzq04z">
              The way most of us have worked for twenty years.
            </figcaption>
          </figure>

          <div className="grid gap-px bg-white/10" data-id="element-455" data-mp="2i75x74wjmc5e">
            <div className="bg-ink-950 p-6 lg:p-8" data-id="element-456" data-mp="2i5bd1st3io2d">
              <p className="font-display text-2xl font-bold uppercase tracking-wide text-steel-400" data-id="element-457" data-mp="2n6ii3k3ut95c">Without X1</p>
              <ul className="mt-4 grid gap-2.5" data-id="element-458" data-mp="3tmujdu1z3755">
                {without.map(item => <li key={item} className="flex items-start gap-3 text-[15px] text-steel-400 sm:text-base" data-id="element-459" data-mp="2eyuss92fnpg">
                    <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-steel-500" aria-hidden="true" data-id="element-460" data-mp="1yhtt4bfu3gpk" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-ink-950 p-6 ring-1 ring-inset ring-grit-500/50 lg:p-8" data-id="element-461" data-mp="27ijl141z4my0">
              <p className="font-display text-2xl font-extrabold uppercase tracking-wide text-grit-500" data-id="element-462" data-mp="23hpxibsg1a5n">With X1</p>
              <ul className="mt-4 grid gap-2.5" data-id="element-463" data-mp="1ftgefhmm70i7">
                {withX1.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium text-offwhite sm:text-base" data-id="element-464" data-mp="1audbc2q734cv">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-grit-500" aria-hidden="true" data-id="element-465" data-mp="1om9zxwsnmw4i" />
                    {item}
                  </li>)}
              </ul>
              <p className="mt-5 text-[15px] text-steel-300" data-id="element-466" data-mp="w33cwa4el3b1">
                Keep both hands on the job while your light stays exactly where you&apos;re looking.
              </p>
            </div>
          </div>
        </div>

        <p className="grit-headline mt-12 text-center text-[clamp(2.5rem,10vw,5.5rem)] font-extrabold uppercase text-offwhite" data-id="element-467" data-mp="hxksqli5gjye">
          Look there.
          <br data-id="element-468" data-mp="81histh23h0w" />
          <span className="text-grit-500" data-id="element-469" data-mp="81rduvgykedg">Light there.</span>
        </p>

        <div className="mt-8 flex justify-center" data-id="element-470" data-mp="cz9lmij8onjv">
          <CtaButton className="w-full sm:w-auto" data-id="element-471" data-mp="d02jeu0802pv">Get your X1</CtaButton>
        </div>
      </div>
    </section>;
}